const getSlimStyles = (isSlim) =>
  isSlim ? "font-medium px-2.5 py-1.5 text-xs" : "px-4 py-2 text-sm"

export { getSlimStyles }
export default getSlimStyles
